// removed by extract-text-webpack-plugin
module.exports = {"BuildControl":"BuildControl-module__BuildControl__3qVkT","Label":"BuildControl-module__Label__2N8RL","Less":"BuildControl-module__Less__1QDcJ","More":"BuildControl-module__More__WUyJm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/BuildControls/BuildControl/BuildControl.module.css
// module id = 111
// module chunks = 0